export const GET_INITIAL_SERVICES = 'GET_INITIAL_SERVICES';
export const FETCHED_SERVICE_CHILDREN = 'FETCHED_SERVICE_CHILDREN';
export const CREATED_SERVICE_SUCCESSFUL = 'CREATED_SERVICE_SUCCESSFUL';
export const EDITED_SERVICE_SUCCESSFUL = 'EDITED_SERVICE_SUCCESSFUL';
export const REMOVED_SERVICE_SUCCESSFUL = 'REMOVED_SERVICE_SUCCESSFUL';
export const FETCHED_PARENT_SERVICES = 'FETCHED_PARENT_SERVICES';
export const SHOW_EXTENSION_MODAL = 'SHOW_EXTENSION_MODAL';
export const FETCHED_CATALOGUE_SERVICE = 'FETCHED_CATALOGUE_SERVICE';
export const CLEAN_CATALOGUE_STORE = 'CLEAN_CATALOGUE_STORE';
export const FETCH_ADDITIONAL_SERVICES_SUCCESS = 'FETCH_ADDITIONAL_SERVICES_SUCCESS';
export const CHANGE_REPEAT_SERVICE = 'CHANGE_REPEAT_SERVICE';
export const FETCH_RECOMMENDED_SERVICES_SUCCESS = 'FETCH_RECOMMENDED_SERVICES_SUCCESS';
export const MAIN_SERVICE_KM = 'MAIN_SERVICE_KM';
export const CUSTOM_SERVICE = 'CUSTOM_SERVICE';
export const LOADING_CUSTOM_SERVICE = 'LOADING_CUSTOM_SERVICE';
export const SET_MAINSERVICE_LOADING = 'SET_MAINSERVICE_LOADING';


// WEBPACK FOOTER //
// ./src/actionTypes/catalogue.js